define("shared/models/ig-reel", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class DynamoIgReel extends _object.default {
    constructor(attrs) {
      super();
      _defineProperty(this, "id", void 0);
      _defineProperty(this, "caption", void 0);
      _defineProperty(this, "createdTime", void 0);
      _defineProperty(this, "hasMedia", void 0);
      _defineProperty(this, "imageUrl", void 0);
      _defineProperty(this, "isCarousel", void 0);
      _defineProperty(this, "isDeleted", void 0);
      _defineProperty(this, "instagramLink", void 0);
      _defineProperty(this, "isStory", void 0);
      _defineProperty(this, "mediaProductType", void 0);
      _defineProperty(this, "scheduledPost", void 0);
      _defineProperty(this, "socialProfile", void 0);
      _defineProperty(this, "standardResUrl", void 0);
      _defineProperty(this, "thumbUrl", void 0);
      _defineProperty(this, "timeCollected", void 0);
      _defineProperty(this, "type", void 0);
      _defineProperty(this, "commentCount", void 0);
      _defineProperty(this, "engagement", void 0);
      _defineProperty(this, "engagements", void 0);
      _defineProperty(this, "exits", void 0);
      _defineProperty(this, "imageMediumUrl", void 0);
      _defineProperty(this, "likeCount", void 0);
      _defineProperty(this, "views", void 0);
      _defineProperty(this, "mediaUrl", void 0);
      _defineProperty(this, "plays", void 0);
      _defineProperty(this, "totalPlays", void 0);
      _defineProperty(this, "reach", void 0);
      _defineProperty(this, "savedCount", void 0);
      _defineProperty(this, "shareCount", void 0);
      _defineProperty(this, "url", void 0);
      _defineProperty(this, "videoViews", void 0);
      this.id = attrs.id;
      this.socialProfile = attrs.socialProfile;
      this.createdTime = attrs.createdTime;
      this.type = attrs.type;
      this.thumbUrl = attrs.thumbUrl;
      this.imageUrl = attrs.imageUrl;
      this.engagement = attrs.engagement;
      this.engagements = attrs.engagements;
      this.reach = attrs.reach;
      this.savedCount = attrs.savedCount;
      this.plays = attrs.plays;
      this.totalPlays = attrs.totalPlays;
      this.shareCount = attrs.shareCount;
      this.commentCount = attrs.commentCount;
      this.likeCount = attrs.likeCount;
      this.views = attrs.views;
      this.standardResUrl = attrs.standardResUrl;
      this.instagramLink = attrs.instagramLink;
      this.caption = attrs.caption;
      this.mediaProductType = attrs.mediaProductType;
      this.isDeleted = attrs.isDeleted;
      this.timeCollected = Date.now();
      this.hasMedia = true;
      this.isStory = false;
      this.isCarousel = attrs.type === 'carousel';
      this.scheduledPost = attrs.scheduledPost;
    }
  }
  _exports.default = DynamoIgReel;
});